import Button from '@rio-cloud/rio-uikit/Button';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import { FormattedMessage } from 'react-intl';

interface EditConfirmationDialogProps {
    show: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export const EditConfirmationDialog = ({ show, onConfirm, onCancel }: EditConfirmationDialogProps) => {
    return (
        <Dialog
            show={show}
            bsSize={Dialog.SIZE_XS}
            showCloseButton={false}
            disableEsc
            title={<FormattedMessage id='intl-msg:smartRoute.tour.editConfirmation.title' />}
            body={<FormattedMessage id='intl-msg:smartRoute.tour.editConfirmation.message' />}
            footer={
                <div className='display-flex justify-content-end gap-10'>
                    <Button bsStyle={Button.DEFAULT} onClick={onCancel}>
                        <FormattedMessage id='intl-msg:smartRoute.tour.editConfirmation.cancel' />
                    </Button>
                    <Button bsStyle={Button.PRIMARY} onClick={onConfirm}>
                        <FormattedMessage id='intl-msg:smartRoute.tour.editConfirmation.confirm' />
                    </Button>
                </div>
            }
        />
    );
};
